import { FONT_SIZE_BASE } from './constants';
export const lineHeights = [
    `${1 - 1 / FONT_SIZE_BASE}rem`,
    `${1 + 2 / FONT_SIZE_BASE}rem`,
    `${1 + 4 / FONT_SIZE_BASE}rem`,
    `${1 + 7 / FONT_SIZE_BASE}rem`,
    `${1 + 9 / FONT_SIZE_BASE}rem`,
    `${1 + 11 / FONT_SIZE_BASE}rem`,
    `${1 + 14 / FONT_SIZE_BASE}rem`,
    `${1 + 16 / FONT_SIZE_BASE}rem`,
    `${1 + 24 / FONT_SIZE_BASE}rem`,
    `${1 + 26 / FONT_SIZE_BASE}rem`,
];
//# sourceMappingURL=lineHeights.js.map